import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Dashboard from './pages/Dashboard'

import ContestDetail from "./pages/ContestDetail";
import PrivateRoute from './components/PrivateRoute'
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Login from './pages/Login'
import Doubts from './pages/Doubts'



export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                {/*Routes of direct customer contact pages*/}
                <Route path="/" exact component={Home} />
                <Route path="/concurso/:id" exact component={ContestDetail} />
                <Route path='/duvidas' exact component={Doubts} />

                {/*Administration routes below*/}
                <Route path='/login' exact component={Login} />
                <PrivateRoute path='/admin' component={Dashboard} />
                {/*here*/}

                {/*Error route*/}
                <Route path="*" component={NotFound} />

            </Switch>
        </BrowserRouter>
    )
}
